import axios from "axios";
import * as types from "../mutation-types";
import logger from "~/utilities/logger";

// state
export const state = {
  sugar_key_users_list: [],
};

// getters
export const getters = {
  sugar_key_users_list: (state) => state.sugar_key_users_list,
};

// mutations
export const mutations = {
  [types.FETCH_SUGAR_KEY_USERS](state, { list })
  {
    state.sugar_key_users_list = list;
  },

  [types.FETCH_SUGAR_KEY_USERS_FAILURE](state)
  {
    logger.error("FETCH_SUGAR_KEY_USERS_FAILURE");
  },

  [types.CREATE_SUGAR_KEY_USER](state, { keyUser })
  {
    state.sugar_key_users_list.unshift(keyUser);
  },

  [types.CREATE_SUGAR_KEY_USER_FAILURE](state)
  {
    logger.error("CREATE_SUGAR_KEY_USER_FAILURE");
  },

  [types.DELETE_SUGAR_KEY_USER](state, { sugar_user_id })
  {
    state.sugar_key_users_list = state.sugar_key_users_list.filter(
      (u) => u.sugar_user_id !== sugar_user_id
    );
  },

  [types.DELETE_SUGAR_KEY_USER_FAILURE](state)
  {
    logger.error("DELETE_SUGAR_KEY_USER_FAILURE");
  },
};

// actions
export const actions = {
  async fetchSugarKeyUsers({ commit })
  {
    try
    {
      const { data } = await axios.get("/api/sugar-keyusers");

      if (data?.status !== "success") throw data;

      const list = data.data ?? [];

      commit(types.FETCH_SUGAR_KEY_USERS, { list });

      return list;
    } catch (e)
    {
      logger.error("fetchSugarKeyUsers", e);
      commit(types.FETCH_SUGAR_KEY_USERS_FAILURE);
      throw e;
    }
  },

  async createSugarKeyUser({ commit }, { sugar_user_id })
  {
    try
    {
      const { data } = await axios.post("/api/sugar-keyusers", { sugar_user_id });

      if (data?.status !== "success") throw data;

      const keyUser = data.data;
      commit(types.CREATE_SUGAR_KEY_USER, { keyUser });

      return keyUser;
    } catch (e)
    {
      logger.error("createSugarKeyUser", e);
      commit(types.CREATE_SUGAR_KEY_USER_FAILURE);
      throw e;
    }
  },

  async deleteSugarKeyUser({ commit }, { sugar_user_id })
  {
    try
    {
      const { data } = await axios.delete(`/api/sugar-keyusers/${sugar_user_id}`);

      if (data?.status !== "success") throw data;

      commit(types.DELETE_SUGAR_KEY_USER, { sugar_user_id });
    } catch (e)
    {
      logger.error("deleteSugarKeyUser", e);
      commit(types.DELETE_SUGAR_KEY_USER_FAILURE);
      throw e;
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
